import React from 'react'

type IconProps = {
  width?: string
  height?: string
  fill?: string
  fillStroke?: string
}

const IconStopCircle = (props: IconProps) => {
  return (

    <svg
      width={props?.width || "24"}
      height={props?.height || "24"}
      viewBox="0 0 24 24"
      fill={props?.fill || "none"}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM15 11H5V9H15V11Z"
        fill={props?.fillStroke || "#5A5A5A"} />
    </svg>


  )
}

export default IconStopCircle